module.exports = __webpack_public_path__ + "img/cachet senegal.b258ce3c.png";